// extracted by mini-css-extract-plugin
export var confirmationHeader = "_wi-0";
export var confirmationIcon = "_wi-1";